var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripe-2"},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_vm._v(" Afíliese ahora ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }